import Nav from "@/components/velvet/Nav";
import Hero from "@/components/velvet/Hero";
import Marquee from "@/components/velvet/Marquee";
import Services from "@/components/velvet/Services";
import GiftStrip from "@/components/velvet/GiftStrip";
import Experience from "@/components/velvet/Experience";
import About from "@/components/velvet/About";
import Gallery from "@/components/velvet/Gallery";
import Credentials from "@/components/velvet/Credentials";
import FAQ from "@/components/velvet/FAQ";
import BookingForm from "@/components/velvet/BookingForm";
import Footer from "@/components/velvet/Footer";
import StickyBookBar from "@/components/velvet/StickyBookBar";

export default function Home() {
  return (
    <div
      data-testid="home-page"
      className="bg-[#0d0906] text-[#f5f3f0] antialiased selection:bg-[#9d0208] selection:text-white min-h-screen"
    >
      <Nav />
      <Hero />
      <Marquee />
      <Services />
      <GiftStrip />
      <Experience />
      <About />
      <Gallery />
      <Credentials />
      <FAQ />
      <BookingForm />
      <Footer />
      <StickyBookBar />
    </div>
  );
}
